// extracted by mini-css-extract-plugin
export default {"container":"II","promoapplied":"JI","tobeapplied":"KI","hr":"LI","teal":"MI","promoappliedcontainer":"NI","error":"OI","input":"PI","errorInput":"QI","promo_x":"RI","promo_info":"SI","promoxcontainer":"TI"};
    if(module.hot) {
      // 1713211521445
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  